import Vue from 'vue'

// document title 指令
Vue.directive('title', {
	inserted: (el: Node, binding: any) => (document.title = binding.value),
	update: (el: Node, binding: any) => (document.title = binding.value),
})
